import {
  DailyFinancialsParams,
  DailyFinancialsResponse,
  DashboardKpis,
  DateRangeParams,
  PendingOrdersParams,
  PendingOrdersResponse,
  RevenueByTypeResponse,
  RevenueTrendParams,
  RevenueTrendResponse
} from '../types/dashboard';
import { authApi } from '../utils/api';

// ── Wrapper types matching the API response envelope ──

interface ApiResponse<T> {
  status: string;
  data: T;
}

// ── Dashboard API Query Functions ──

export const getDashboardKpis = async (params: DateRangeParams) =>
  (await authApi<ApiResponse<DashboardKpis>>({ method: 'GET', url: '/dashboard/kpis', params: { ...params } })).data;

export const getDailyFinancials = async (params: DailyFinancialsParams) =>
  (
    await authApi<ApiResponse<DailyFinancialsResponse>>({
      method: 'GET',
      url: '/dashboard/daily-financials',
      params: { ...params }
    })
  ).data;

export const getRevenueByType = async (params: DateRangeParams) =>
  (
    await authApi<ApiResponse<RevenueByTypeResponse>>({
      method: 'GET',
      url: '/dashboard/revenue-by-type',
      params: { ...params }
    })
  ).data;

export const getPendingOrders = async (params?: PendingOrdersParams) =>
  (
    await authApi<ApiResponse<PendingOrdersResponse>>({
      method: 'GET',
      url: '/dashboard/pending-orders',
      params: params ? { ...params } : undefined
    })
  ).data;

export const getRevenueTrend = async (params: RevenueTrendParams) =>
  (
    await authApi<ApiResponse<RevenueTrendResponse>>({
      method: 'GET',
      url: '/dashboard/revenue-trend',
      params: { ...params }
    })
  ).data;
